import Component from '../abstracts/Component';

export default class BurgerComponent extends Component {

  get SELECTORS() {
    return {
      burger: '[data-burger]'
    }
  }

  get CLASSES() {
    return {
      active: 'is-active'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {

    this.$on('click.burger', () => {
      $(this.SELECTORS.burger).toggleClass(this.CLASSES.active);
      this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: $(this.SELECTORS.burger).hasClass(this.CLASSES.active)});

    }, this.SELECTORS.burger);

    this.$on(this.$customEvents.QUICK_CATEGORIES_EVENTS.visible, () => {
      setTimeout(() => {
        $(this.SELECTORS.burger).toggleClass(this.CLASSES.active);
        this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: $(this.SELECTORS.burger).hasClass(this.CLASSES.active)});
      }, 300);
    })

    // al passaggio da sm/md a lg chiudo il menu
    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        $(this.SELECTORS.burger).removeClass(this.CLASSES.active);
        this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: false});
        $('.main-header').removeClass('is-top');
      }
    });
  }

  render() {
    this.bindEvents();

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.show, () => {
      $(this.SELECTORS.burger).removeClass(this.CLASSES.active);
        this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: false});

    })
  }

}
